module.exports = __webpack_public_path__ + "img/credit_card_payment.a63ec734.png";